import { render, staticRenderFns } from "./solicitud.vue?vue&type=template&id=b750f7b2&"
import script from "./solicitud.vue?vue&type=script&lang=js&"
export * from "./solicitud.vue?vue&type=script&lang=js&"
import style0 from "./solicitud.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports